export const marketPlaceData = [
    {
        head:"Most Visited Topics",
        child1:"Taxes",
        child2:"Health insurance"
    },
    {
        head:"Comments & Replies",
        child1:"12 comments",
        child2:"27 replies"
    },
    {
        head:"Profile Views",
        child1:"27 views in the past day",
        child2:"3,125 views total"
    },
    {
        head:"Number of Policies Impacted",
        child1:"3 policies changed",
        child2:"2 policies recalled"
    },
    {
        head:"# of Interactions a Day",
        child1:"2.3 interactons",
        child2:""
    },
    {
        head:"Amount of Hours Spent",
        child1:"17 hours total",
        child2:"1.2 hours a day"
    },
    {
        head:"Length of Conversations",
        child1:"214 hours total",
        child2:"1.2 hours a day"
    },


]


export const avatarColors = [
    "#C40C0C", "#FF6500", "#10439F", "#1679AB", "#003C43", "#481E14",
    "#D20062", "#E8751A", "5F5D9C"
]


export const dataList = [
    "Quality Score", "Profile Completeness", "Relevance Score",
    "Personality Profile", "Chat History", "Discussion Activity"
]